import { useQuery } from '@tanstack/react-query';
import { queryKeys, type DashboardPeriod } from '../../shared/data/queryKeys';
import { getRanking, type RankingMetric } from './api';

export function useRanking(metric: RankingMetric, period: DashboardPeriod) {
  return useQuery({
    queryKey: queryKeys.ranking(metric, period),
    queryFn: () => getRanking(metric, period),
  });
}
